import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import { Switch, Table } from "antd";
import { MEMBER_INTERVIEW_RECORD_COLUMNS, OPPORTUNITY_ALLOCATION_COLUMNS, OPPORTUNITY_APPLICANT_INTERVIEW_COLUMN, OPPORTUNITY_APPLICATION_COLUMNS, OPPORTUNITY_MASTER_COLUMNS, OPPORTUNITY_TYPE_COLUMNS } from "../constant/AppConstant";
import { BsDownload, BsFillFileEarmarkBarGraphFill, BsPencilSquare, BsPlus, BsSearch } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import Loading from "../Loading";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useDownloadReportMutation } from "../../redux-toolkit/services/opportunityApplicationService";
import { useDeleteOpportunityTypeMutation, useGetAllOpportunityTypeBySearchMutation, useGetAllOpportunityTypeMutation } from "../../redux-toolkit/services/opportunityTypeService";
import { getAllOpportunityTypeBySearch, getOpportunityTypeDetails, getOpportunityTypeTotalRecords, setAllOpportunityTypeBySearch, setOpportunityType } from "../../redux-toolkit/slices/opportunityTypeSlice";
import { getAllInvestmentMandateTypeDetails } from "../../redux-toolkit/slices/investmentMandateTypeSlice";
import { FaFileAlt } from "react-icons/fa";
import { marked } from "marked";
import { useDeleteOpportunityMasterMutation, useGetAllOpportunityMasterBySearchMutation, useGetAllOpportunityMasterMutation } from "../../redux-toolkit/services/opportunityMasterService";
import { getAllOpportunityMasterBySearch, getOpportunityMasterDetails, getOpportunityMasterTotalRecords, setAllOpportunityMasterBySearch, setOpportunityMaster } from "../../redux-toolkit/slices/opportunityMasterSlice";
import OpportunityData from "./OpportunityData";
import { useDeleteOpportunityApplicationMutation, useGetAllOpportunityApplicationBySearchMutation, useGetAllOpportunityApplicationMutation } from "../../redux-toolkit/services/opportunityApplicationService";
import { useDeleteOpportunityAllocationMutation, useGetAllOpportunityAllocationBySearchMutation, useGetAllOpportunityAllocationMutation } from "../../redux-toolkit/services/opportunityAllocationService";
import { useDeleteMemberInterviewRecordMutation, useGetAllMemberInterviewRecordBySearchMutation, useGetAllMemberInterviewRecordMutation } from "../../redux-toolkit/services/memberInterviewRecordService";
import { getAllOpportunityApplicationBySearch, getOpportunityApplicationDetails, getOpportunityApplicationTotalRecords, setAllOpportunityApplicationBySearch, setOpportunityApplication } from "../../redux-toolkit/slices/opportunityApplicationSlice";
import { getAllOpportunityAllocationBySearch, getOpportunityAllocationDetails, getOpportunityAllocationTotalRecords, setAllOpportunityAllocationBySearch, setOpportunityAllocation } from "../../redux-toolkit/slices/opportunityAllocationSlice";
import { getAllMemberInterviewRecordBySearch, getMemberInterviewRecordDetails, getMemberInterviewRecordTotalRecords, setAllMemberInterviewRecordBySearch, setMemberInterviewRecord } from "../../redux-toolkit/slices/memberInterviewRecordSlice";
import { useDeleteOpportunityApplicationInterviewMutation, useGetAllOpportunityApplicationInterviewBySearchMutation, useGetAllOpportunityApplicationInterviewMutation } from "../../redux-toolkit/services/opportunityApplicationInterviewService";
import { getAllOpportunityApplicationInterviewBySearch, getOpportunityApplicationInterviewDetails, getOpportunityApplicationInterviewTotalRecords, setAllOpportunityApplicationInterviewBySearch, setOpportunityApplicationInterview } from "../../redux-toolkit/slices/opportunityApplicationInterviewSlice";
import { format, parseISO } from "date-fns";

type Props = {};
const Opportunity = (props: Props) => {

    const params = useParams();
    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");
    const token: any = getLocalStorageData("localUser").token;

    //state
    const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
    const [reportName, setReportName]: any = useState();
    const [currentpage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedRow, setSelectedRow]: any = useState([]);
    const [columData, setColumnData]: any = useState();
    const [dataSource, setDatasource]: any = useState([]);
    const [call, setCall] = useState("N");
    const [isCategory, setIsCategory] = useState(false);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [previewType, setPreviewType]: any = useState<string | null>(null);
    const [html, setHtml] = useState("");
    const [recordData, setRecordData]: any = useState("");

    //getMutations
    const [getAllOpportunityMaster, allOpportunityMasterResponse] = useGetAllOpportunityMasterMutation();
    const [getAllOpportunityType, allOpportunityTypeResponse] = useGetAllOpportunityTypeMutation();
    const [getAllOpportunityApplication, allOpportunityApplicationResponse] = useGetAllOpportunityApplicationMutation();
    const [getAllOpportunityApplicationInterview, allOpportunityApplicationInterviewResponse] = useGetAllOpportunityApplicationInterviewMutation();
    const [getAllOpportunityAllocation, allOpportunityAllocationResponse] = useGetAllOpportunityAllocationMutation();
    const [getAllMemberInterviewRecord, allMemberInterviewRecordResponse] = useGetAllMemberInterviewRecordMutation();

    //search
    const [getAllOpportunityMasterWithSearch, allOpportunityMasterWithSearchResponse] = useGetAllOpportunityMasterBySearchMutation();
    const [getAllOpportunityTypeWithSearch, allOpportunityTypeWithSearchResponse] = useGetAllOpportunityTypeBySearchMutation();
    const [getAllOpportunityApplicationWithSearch, allOpportunityApplicationWithSearchResponse] = useGetAllOpportunityApplicationBySearchMutation();
    const [getAllOpportunityApplicationInterviewWithSearch, allOpportunityApplicationInterviewWithSearchResponse] = useGetAllOpportunityApplicationInterviewBySearchMutation();
    const [getAllOpportunityAllocationWithSearch, allOpportunityAllocationWithSearchResponse] = useGetAllOpportunityAllocationBySearchMutation();
    const [getAllMemberInterviewRecordWithSearch, allMemberInterviewRecordWithSearchResponse] = useGetAllMemberInterviewRecordBySearchMutation();

    //delete mutation
    const [deleteOpportunityMaster, deleteOpportunityMasterResponse] = useDeleteOpportunityMasterMutation();
    const [deleteOpportunityType, deleteOpportunityTypeResponse] = useDeleteOpportunityTypeMutation();
    const [deleteOpportunityApplication, deleteOpportunityApplicationResponse] = useDeleteOpportunityApplicationMutation();
    const [deleteOpportunityApplicationInterview, deleteOpportunityApplicationInterviewResponse] = useDeleteOpportunityApplicationInterviewMutation();
    const [deleteOpportunityAllocation, deleteOpportunityAllocationResponse] = useDeleteOpportunityAllocationMutation();
    const [deleteMemberInterviewRecord, deleteMemberInterviewRecordResponse] = useDeleteMemberInterviewRecordMutation();

    const [downloadReport, downloadReportResponse] = useDownloadReportMutation();

    //totalRecords
    const totalOpportunityMaster: any = useAppSelector(getOpportunityMasterTotalRecords);
    const totalOpportunityType: any = useAppSelector(getOpportunityTypeTotalRecords);
    const totalOpportunityApplication: any = useAppSelector(getOpportunityApplicationTotalRecords);
    const totalOpportunityApplicationInterview: any = useAppSelector(getOpportunityApplicationInterviewTotalRecords);
    const totalOpportunityAllocation: any = useAppSelector(getOpportunityAllocationTotalRecords);
    const totalMemberInterviewRecord: any = useAppSelector(getMemberInterviewRecordTotalRecords);

    //selector

    const allOpportunityMaster: any = useAppSelector(getOpportunityMasterDetails)
    const allOpportunityMasterBySearch: any = useAppSelector(getAllOpportunityMasterBySearch);
    const allOpportunityType: any = useAppSelector(getOpportunityTypeDetails)
    const allOpportunityTypeBySearch: any = useAppSelector(getAllOpportunityTypeBySearch);
    const allInvestmentMandateType: any = useAppSelector(getAllInvestmentMandateTypeDetails)
    const allOpportunityApplication: any = useAppSelector(getOpportunityApplicationDetails);
    const allOpportunityApplicationBySearch: any = useAppSelector(getAllOpportunityApplicationBySearch);
    const allOpportunityApplicationInterview: any = useAppSelector(getOpportunityApplicationInterviewDetails);
    const allOpportunityApplicationInterviewBySearch: any = useAppSelector(getAllOpportunityApplicationInterviewBySearch);
    const allOpportunityAllocation: any = useAppSelector(getOpportunityAllocationDetails);
    const allOpportunityAllocationBySearch: any = useAppSelector(getAllOpportunityAllocationBySearch);
    const allMemberInterviewRecord: any = useAppSelector(getMemberInterviewRecordDetails);
    const allMemberInterviewRecordBySearch: any = useAppSelector(getAllMemberInterviewRecordBySearch);

    useEffect(() => {
        switch (params.reportType) {
            case REPORT_PATH.OPPORTUNITY_TYPE:
                setReportName(REPORT_NAME.OPPORTUNITY_TYPE)
                break;
            case REPORT_PATH.OPPORTUNITY_MASTER:
                setReportName(REPORT_NAME.OPPORTUNITY_MASTER)
                break;
            case REPORT_PATH.OPPORTUNITY_ALLOCATION:
                setReportName(REPORT_NAME.OPPORTUNITY_ALLOCATION)
                break;
            case REPORT_PATH.OPPORTUNITY_APPLICATION:
                setReportName(REPORT_NAME.OPPORTUNITY_APPLICATION)
                break;
            case REPORT_PATH.OPPORTUNITY_APPLICANT_INTERVIEW:
                setReportName(REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW)
                break;
            case REPORT_PATH.MEMBER_INTERVIEW_RECORDS:
                setReportName(REPORT_NAME.MEMBER_INTERVIEW_RECORDS)
                break;
            default:
        }
    }, [params.reportType]);

    const handleFileShow = (record: any) => {
        setHtml("");
        if (!(record.fileData)) {
            setPreviewUrl(null);
            setPreviewType(null);
            return
        }

        // Revoke old preview if exists
        if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
        }

        let mimeType = "application/octet-stream";

        if ((record.fileData).startsWith("/9j")) mimeType = "image/jpeg";
        else if ((record.fileData).startsWith("iVBOR")) mimeType = "image/png";
        else if ((record.fileData).startsWith("JVBER")) mimeType = "application/pdf";
        else if ((record.fileData).startsWith("UEsDB")) mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; // XLSX
        else if ((record.fileData).startsWith("PK")) mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; // DOCX (optional)

        // Convert Base64 → Blob
        const byteCharacters = atob((record.fileData));
        const byteNumbers = new Array(byteCharacters.length).fill(0)
            .map((_, i) => byteCharacters.charCodeAt(i));
        const blob = new Blob([new Uint8Array(byteNumbers)], { type: mimeType });

        const url = URL.createObjectURL(blob);
        setPreviewUrl(url);
        setPreviewType(mimeType);
    }

    const handleShowReport = (record: any) => {
        setPreviewUrl(null);
        setPreviewType(null);

        const response = JSON.parse(record?.llmResponse);
        const finalContent = response?.choices?.[0]?.message?.content || "";
        const html: any = marked(finalContent);
        setHtml(html);
        setRecordData(record);
    }

    useEffect(() => {
        const temp: any = [];
        const tempAction: any = {
            title: "Action",
            dataIndex: "action",
            key: "name",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    // for delete switch button
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ||
                                    record.enabled === true ||
                                    record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                                checked={
                                    record.status === true ||
                                        record.enabled === true ||
                                        record.isActive === true
                                        ? true
                                        : false
                                }
                                onClick={() => {
                                    console.log(record, "record")
                                    onDeleteData(record);
                                }}
                            />
                        </div>
                        {reportName === REPORT_NAME.ENTITY_MASTER && record.fileData !== null && (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleFileShow(record);
                                }}
                            >
                                <FaFileAlt size={18} color="#0078d4" />
                            </div>
                        )}
                        {record.status === true ||
                            record.enabled === true ||
                            record.isActive === true ? (
                            <div
                                className="px-2 pe-auto"
                                onClick={() => {
                                    handleOpenForm(record);
                                }}
                            >
                                <BsPencilSquare size={18} />
                            </div>
                        ) : null}
                    </div>
                );
            },
        };

        const tempAction2: any = {
            title: "Reports",
            dataIndex: "reports",
            key: "reports",
            fixed: "right",
            width: 120,
            render: (index: any, record: any) => {
                return (
                    <div className="d-flex justify-content-between">
                        {reportName === REPORT_NAME.OPPORTUNITY_APPLICATION &&
                            record?.llmResponse !== null &&
                            record?.llmResponse?.trim() !== "" && (
                                <div
                                    className="px-2 pe-auto"
                                    onClick={() => {
                                        handleShowReport(record);
                                    }}
                                >
                                    <BsFillFileEarmarkBarGraphFill size={18} color="#0078d4" />
                                </div>
                            )}
                    </div>
                );
            },
        };

        if (reportName === REPORT_NAME.OPPORTUNITY_TYPE && OPPORTUNITY_TYPE_COLUMNS) {
            OPPORTUNITY_TYPE_COLUMNS.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.OPPORTUNITY_MASTER && OPPORTUNITY_MASTER_COLUMNS) {
            OPPORTUNITY_MASTER_COLUMNS.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICATION && OPPORTUNITY_APPLICATION_COLUMNS) {
            OPPORTUNITY_APPLICATION_COLUMNS.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            temp.push(tempAction2);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW && OPPORTUNITY_APPLICANT_INTERVIEW_COLUMN) {
            OPPORTUNITY_APPLICANT_INTERVIEW_COLUMN.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION && OPPORTUNITY_ALLOCATION_COLUMNS) {
            OPPORTUNITY_ALLOCATION_COLUMNS.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS && MEMBER_INTERVIEW_RECORD_COLUMNS) {
            MEMBER_INTERVIEW_RECORD_COLUMNS.map((item: any) => {
                temp.push(item);
            });
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    useEffect(() => {
        if (reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
            getAllOpportunityType({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
            getAllOpportunityMaster({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
            getAllOpportunityAllocation({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
            getAllMemberInterviewRecord({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
            getAllOpportunityApplication({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
            getAllOpportunityApplicationInterview({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        }
    }, [reportName]);

    useEffect(() => {
        if (call === "Y") {
            if (reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
                getAllOpportunityMaster({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
                getAllOpportunityType({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
                getAllOpportunityAllocation({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
                getAllMemberInterviewRecord({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
                getAllOpportunityApplication({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
                getAllOpportunityApplicationInterview({
                    token: localUserObj?.token,
                    page: currentpage - 1,
                    size: pageSize,
                    sort: "desc",
                });
                setCall("N");
            }
        }
    }, [call]);

    const paginationChange = (page: number, pageSize: number) => {
        if (reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
            getAllOpportunityType({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
            getAllOpportunityMaster({
                token: localUserObj?.token,
                page: page - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
            getAllOpportunityAllocation({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
            getAllMemberInterviewRecord({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
            getAllOpportunityApplication({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
            getAllOpportunityApplicationInterview({
                token: localUserObj?.token,
                page: currentpage - 1,
                size: pageSize,
                sort: "desc",
            });
        }
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleShow = () => {
        setActionType(ACTION_TYPE.ADD_ACTION);
        setShow(true)
    };

    const onDeleteData = (record: any) => {
        if (reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
            deleteOpportunityType({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
            deleteOpportunityMaster({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
            deleteOpportunityApplication({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
            deleteOpportunityAllocation({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
            deleteMemberInterviewRecord({ token: localUserObj?.token, id: record.id });

        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
            deleteOpportunityApplicationInterview({ token: localUserObj?.token, id: record.id });
        }
    };

    useEffect(() => {
        if (deleteOpportunityMasterResponse.isSuccess) {
            if (deleteOpportunityMasterResponse.data?.isActive) {
                alertMessage("Opportunity Master enable successfully", "success");
            } else {
                alertMessage("Opportunity Master deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteOpportunityMasterResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteOpportunityMasterResponse.isSuccess, deleteOpportunityMasterResponse.isError]);

    useEffect(() => {
        if (deleteOpportunityTypeResponse.isSuccess) {
            if (deleteOpportunityTypeResponse.data?.isActive) {
                alertMessage("Opportuntiy Type enable successfully", "success");
            } else {
                alertMessage("Opportuntiy Type deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteOpportunityTypeResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteOpportunityTypeResponse.isSuccess, deleteOpportunityTypeResponse.isError]);

    useEffect(() => {
        if (deleteOpportunityApplicationResponse.isSuccess) {
            if (deleteOpportunityApplicationResponse.data?.isActive) {
                alertMessage("Opportunity Application enable successfully", "success");
            } else {
                alertMessage("Opportunity Application deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteOpportunityApplicationResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteOpportunityApplicationResponse.isSuccess, deleteOpportunityApplicationResponse.isError]);

    useEffect(() => {
        if (deleteOpportunityApplicationInterviewResponse.isSuccess) {
            if (deleteOpportunityApplicationInterviewResponse.data?.isActive) {
                alertMessage("Opportuntiy Application Interview enable successfully", "success");
            } else {
                alertMessage("Opportuntiy Application Interview deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteOpportunityApplicationInterviewResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteOpportunityApplicationInterviewResponse.isSuccess, deleteOpportunityApplicationInterviewResponse.isError]);

    useEffect(() => {
        if (deleteOpportunityAllocationResponse.isSuccess) {
            if (deleteOpportunityAllocationResponse.data?.isActive) {
                alertMessage("Opportunity Allocation enable successfully", "success");
            } else {
                alertMessage("Opportunity Allocation deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteOpportunityAllocationResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteOpportunityAllocationResponse.isSuccess, deleteOpportunityAllocationResponse.isError]);

    useEffect(() => {
        if (deleteMemberInterviewRecordResponse.isSuccess) {
            if (deleteMemberInterviewRecordResponse.data?.isActive) {
                alertMessage("Member Interview Record enable successfully", "success");
            } else {
                alertMessage("Member Interview Record deleted successfully", "success");
            }
            setCall("Y");
        } else if (deleteMemberInterviewRecordResponse.isError) {
            alertMessage("Error while deleting", "error");
        }
    }, [deleteMemberInterviewRecordResponse.isSuccess, deleteMemberInterviewRecordResponse.isError]);


    const handleOpenForm = (record: any) => {
        setActionType(ACTION_TYPE.UPDATE_ACTION);
        setSelectedRow(record);
        setShow(true);
    };

    useEffect(() => {
        if (allOpportunityMasterResponse.isSuccess) {
            dispatch(setOpportunityMaster(allOpportunityMasterResponse));
        } else if (allOpportunityMasterResponse.isError) {
            let response: any = allOpportunityMasterResponse.error;
            alertMessage(response, "error");
        }

    }, [allOpportunityMasterResponse.isSuccess, allOpportunityMasterResponse.isError]);

    useEffect(() => {
        if (allOpportunityTypeResponse.isSuccess) {
            dispatch(setOpportunityType(allOpportunityTypeResponse));
        } else if (allOpportunityTypeResponse.isError) {
            let response: any = allOpportunityTypeResponse.error;
            alertMessage(response, "error");
        }

    }, [allOpportunityTypeResponse.isSuccess, allOpportunityTypeResponse.isError]);

    useEffect(() => {
        if (allOpportunityApplicationResponse.isSuccess) {
            dispatch(setOpportunityApplication(allOpportunityApplicationResponse));
        } else if (allOpportunityApplicationResponse.isError) {
            let response: any = allOpportunityApplicationResponse.error;
            alertMessage(response, "error");
        }
    }, [allOpportunityApplicationResponse.isSuccess, allOpportunityApplicationResponse.isError])

    useEffect(() => {
        if (allOpportunityApplicationInterviewResponse.isSuccess) {
            dispatch(setOpportunityApplicationInterview(allOpportunityApplicationInterviewResponse));
        } else if (allOpportunityApplicationInterviewResponse.isError) {
            let response: any = allOpportunityApplicationInterviewResponse.error;
            alertMessage(response, "error");
        }
    }, [allOpportunityApplicationInterviewResponse.isSuccess, allOpportunityApplicationInterviewResponse.isError])

    useEffect(() => {
        if (allOpportunityAllocationResponse.isSuccess) {
            dispatch(setOpportunityAllocation(allOpportunityAllocationResponse));
        } else if (allOpportunityAllocationResponse.isError) {
            let response: any = allOpportunityAllocationResponse.error;
            alertMessage(response, "error");
        }
    }, [allOpportunityAllocationResponse.isSuccess, allOpportunityAllocationResponse.isError]);

    useEffect(() => {
        if (allMemberInterviewRecordResponse.isSuccess) {
            dispatch(setMemberInterviewRecord(allMemberInterviewRecordResponse));
        } else if (allMemberInterviewRecordResponse.isError) {
            let response: any = allMemberInterviewRecordResponse.error;
            alertMessage(response, "error");
        }
    }, [allMemberInterviewRecordResponse.isSuccess, allMemberInterviewRecordResponse.isError]);


    //data
    useEffect(() => {
        if (allOpportunityMaster && reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
            setDatasource(allOpportunityMaster);
        }
    }, [allOpportunityMaster]);

    useEffect(() => {
        if (allOpportunityType && reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
            setDatasource(allOpportunityType);
        }
    }, [allOpportunityType]);

    useEffect(() => {
        if (allInvestmentMandateType && reportName === REPORT_NAME.INVESTMENT_MANDATE_TYPE) {
            setDatasource(allInvestmentMandateType);
        }
    }, [allInvestmentMandateType]);

    useEffect(() => {
        if (allOpportunityAllocation && reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
            setDatasource(allOpportunityAllocation);
        }
    }, [allOpportunityAllocation]);


    useEffect(() => {
        if (allOpportunityApplication && reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
            setDatasource(allOpportunityApplication);
        }
    }, [allOpportunityApplication]);

    useEffect(() => {
        if (allOpportunityApplicationInterview && reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
            setDatasource(allOpportunityApplicationInterview);
        }
    }, [allOpportunityApplicationInterview]);

    useEffect(() => {
        if (allMemberInterviewRecord && reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
            setDatasource(allMemberInterviewRecord);
        }
    }, [allMemberInterviewRecord]);

    const handleSearch = (event: any) => {
        if (reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
            getAllOpportunityTypeWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
            getAllOpportunityMasterWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
            getAllOpportunityAllocationWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
            getAllMemberInterviewRecordWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
            getAllOpportunityApplicationWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        } else if (reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
            getAllOpportunityApplicationInterviewWithSearch({
                token: localUserObj?.token,
                payload: { offset: 1000, pageNumber: 0, searchBy: event.target.value },
            });
        }
    };

    useEffect(() => {
        if (allOpportunityMasterWithSearchResponse.isSuccess) {
            dispatch(setAllOpportunityMasterBySearch(allOpportunityMasterWithSearchResponse));
        } else if (allOpportunityMasterWithSearchResponse.isError) {
            let response: any = allOpportunityMasterWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allOpportunityMasterWithSearchResponse.isSuccess, allOpportunityMasterWithSearchResponse.isError]);

    useEffect(() => {
        if (allOpportunityTypeWithSearchResponse.isSuccess) {
            dispatch(setAllOpportunityTypeBySearch(allOpportunityTypeWithSearchResponse));
        } else if (allOpportunityTypeWithSearchResponse.isError) {
            let response: any = allOpportunityTypeWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allOpportunityTypeWithSearchResponse.isSuccess, allOpportunityTypeWithSearchResponse.isError]);

    useEffect(() => {
        if (allOpportunityApplicationWithSearchResponse.isSuccess) {
            dispatch(setAllOpportunityApplicationBySearch(allOpportunityApplicationWithSearchResponse));
        } else if (allOpportunityApplicationWithSearchResponse.isError) {
            let response: any = allOpportunityApplicationWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allOpportunityApplicationWithSearchResponse.isSuccess, allOpportunityApplicationWithSearchResponse.isError]);

    useEffect(() => {
        if (allOpportunityApplicationInterviewWithSearchResponse.isSuccess) {
            dispatch(setAllOpportunityApplicationInterviewBySearch(allOpportunityApplicationInterviewWithSearchResponse));
        } else if (allOpportunityApplicationInterviewWithSearchResponse.isError) {
            let response: any = allOpportunityApplicationInterviewWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allOpportunityApplicationInterviewWithSearchResponse.isSuccess, allOpportunityApplicationInterviewWithSearchResponse.isError]);

    useEffect(() => {
        if (allOpportunityAllocationWithSearchResponse.isSuccess) {
            dispatch(setAllOpportunityAllocationBySearch(allOpportunityAllocationWithSearchResponse));
        } else if (allOpportunityAllocationWithSearchResponse.isError) {
            let response: any = allOpportunityAllocationWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allOpportunityAllocationWithSearchResponse.isSuccess, allOpportunityAllocationWithSearchResponse.isError]);

    useEffect(() => {
        if (allMemberInterviewRecordWithSearchResponse.isSuccess) {
            dispatch(setAllMemberInterviewRecordBySearch(allMemberInterviewRecordWithSearchResponse));
        } else if (allMemberInterviewRecordWithSearchResponse.isError) {
            let response: any = allMemberInterviewRecordWithSearchResponse.error;
            alertMessage(response, "error");
        }
    }, [allMemberInterviewRecordWithSearchResponse.isSuccess, allMemberInterviewRecordWithSearchResponse.isError]);


    useEffect(() => {
        if (allOpportunityMasterBySearch && reportName === REPORT_NAME.OPPORTUNITY_MASTER) {
            setDatasource(allOpportunityMasterBySearch);
        }
    }, [allOpportunityMasterBySearch]);

    useEffect(() => {
        if (allOpportunityTypeBySearch && reportName === REPORT_NAME.OPPORTUNITY_TYPE) {
            setDatasource(allOpportunityTypeBySearch);
        }
    }, [allOpportunityTypeBySearch]);

    useEffect(() => {
        if (allOpportunityApplicationBySearch && reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
            setDatasource(allOpportunityApplicationBySearch);
        }
    }, [allOpportunityApplicationBySearch]);

    useEffect(() => {
        if (allOpportunityApplicationInterviewBySearch && reportName === REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW) {
            setDatasource(allOpportunityApplicationInterviewBySearch);
        }
    }, [allOpportunityApplicationInterviewBySearch]);


    useEffect(() => {
        if (allOpportunityAllocationBySearch && reportName === REPORT_NAME.OPPORTUNITY_ALLOCATION) {
            setDatasource(allOpportunityAllocationBySearch);
        }
    }, [allOpportunityAllocationBySearch]);

    useEffect(() => {
        if (allMemberInterviewRecordBySearch && reportName === REPORT_NAME.MEMBER_INTERVIEW_RECORDS) {
            setDatasource(allMemberInterviewRecordBySearch);
        }
    }, [allMemberInterviewRecordBySearch]);

    const handleDownloadRreport = () => {
        if (reportName === REPORT_NAME.OPPORTUNITY_APPLICATION) {
            // recordData
            const tableData = [
                {
                    applicantName: recordData.name,
                    email: recordData.email,
                    phoneNumber: recordData.phoneNumber,
                    entityType: recordData.entityTypeMaster?.name,
                    entity: recordData.entityMaster?.name,
                    opportunityType: recordData.opportunityType?.name,
                    opportunity: recordData.opportunity?.name,
                    source: recordData.source,
                    followupDetails: recordData.followupDetails,
                    followupDate: format(parseISO(recordData.followupDate), "yyyy-MM-dd"),
                }
            ]

            const response = JSON.parse(recordData?.llmResponse);
            const finalContent = response?.choices?.[0]?.message?.content || "";

            const payload = {
                opportunityTableData: tableData,     // array of RowData
                llmResponse: finalContent         // HTML string from LLM
            };

            downloadReport({
                token: localUserObj?.token,
                payload
            })
                .unwrap()
                .then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "Due_Diligence.pdf";
                    link.click();
                    window.URL.revokeObjectURL(url);

                    alertMessage("Report downloaded successfully", "success");
                })
                .catch((error) => {
                    alertMessage("Error while downloading", "error");
                });
        }
    }

    return (
        <div className="mt-2 overflow-y-auto">
            <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
                <div className="d-flex align-items-center w-100 px-2">
                    <h5
                        className="m-0 px-0 d-flex align-items-center text-accent"
                        style={{ fontWeight: "700" }}
                    >
                        {reportName}
                    </h5>
                </div>
                <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
                    <div className="d-flex flex-column">
                        <div className="input-group px-2 mt-1">
                            <Form.Control
                                type="search"
                                placeholder="Search"
                                className="border-0 bg-cm-light-primary1"
                                aria-label="Search"
                                onChange={handleSearch}
                            />
                            <div className="input-group-append bg-cm-light-primary1 p-1 rounded-end">
                                <span className="input-group-text bg-cm-light-primary1 border-0">
                                    {/* <img src={gear} alt="" /> */}
                                    <BsSearch className=" bg-cm-light-primary1 border-cm-light-primary1" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex px-2 align-items-center mt-1">
                        <Button
                            // variant="primary"
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                            onClick={handleShow}
                        >
                            <BsPlus />
                            Add
                        </Button>
                    </div>
                    {allOpportunityMasterResponse.isLoading ||
                        allOpportunityTypeResponse.isLoading ||
                        allOpportunityApplicationResponse.isLoading ||
                        allOpportunityApplicationInterviewResponse.isLoading ||
                        allOpportunityAllocationResponse.isLoading ||
                        allMemberInterviewRecordResponse.isLoading ||

                        allOpportunityMasterWithSearchResponse.isLoading ||
                        allOpportunityTypeWithSearchResponse.isLoading ||
                        allOpportunityApplicationWithSearchResponse.isLoading ||
                        allOpportunityApplicationInterviewWithSearchResponse.isLoading ||
                        allOpportunityAllocationWithSearchResponse.isLoading ||
                        allMemberInterviewRecordWithSearchResponse.isLoading ||

                        deleteOpportunityMasterResponse.isLoading ||
                        deleteOpportunityTypeResponse.isLoading ||
                        deleteOpportunityApplicationResponse.isLoading ||
                        deleteOpportunityApplicationInterviewResponse.isLoading ||
                        deleteOpportunityAllocationResponse.isLoading ||
                        deleteMemberInterviewRecordResponse.isLoading
                        ? (
                            <Loading />
                        ) : (
                            ""
                        )}
                    {show && (
                        <OpportunityData
                            show={show}
                            setShow={setShow}
                            actionType={actionType}
                            reportName={reportName}
                            data={selectedRow}
                            setCall={setCall}
                            isCategory={isCategory}
                            setIsCategory={setIsCategory}
                        />
                    )}
                </div>
            </div>
            <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
                <Table
                    bordered={true}
                    rowKey={"id"}
                    scroll={{ x: 'max-content' }}
                    tableLayout="fixed"
                    pagination={{
                        total: (() => {
                            switch (reportName) {
                                case REPORT_NAME.OPPORTUNITY_TYPE:
                                    return totalOpportunityType;
                                case REPORT_NAME.OPPORTUNITY_MASTER:
                                    return totalOpportunityMaster;
                                case REPORT_NAME.OPPORTUNITY_APPLICATION:
                                    return totalOpportunityApplication;
                                case REPORT_NAME.OPPORTUNITY_APPLICANT_INTERVIEW:
                                    return totalOpportunityApplicationInterview;
                                case REPORT_NAME.OPPORTUNITY_ALLOCATION:
                                    return totalOpportunityAllocation;
                                case REPORT_NAME.MEMBER_INTERVIEW_RECORDS:
                                    return totalMemberInterviewRecord;
                                default:
                                    return dataSource.length;
                            }
                        })(),
                        responsive: true,
                        current: currentpage,
                        // showSizeChanger: true,  
                        pageSizeOptions: [10, 20, 30],
                        onChange: (page, pageSize) => {
                            paginationChange(page, pageSize);
                        },
                        pageSize: pageSize,
                    }}
                    columns={columData}
                    dataSource={dataSource}
                />
            </div>
            <div className="file-preview" style={{ marginTop: "20px" }}>
                {previewUrl && (
                    <>
                        {/* IMAGE VIEWER */}
                        {(previewType.includes("image")) && (
                            <img
                                src={previewUrl}
                                alt="Preview"
                                style={{ maxWidth: "100%", borderRadius: "8px" }}
                            />
                        )}

                        {/* PDF VIEWER */}
                        {previewType === "application/pdf" && (
                            <iframe
                                src={previewUrl}
                                width="100%"
                                height="500px"
                                style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                            />
                        )}

                        {/* EXCEL / WORD / ZIP — cannot be previewed */}
                        {(previewType.includes("spreadsheet") ||
                            previewType.includes("word") ||
                            previewType.includes("octet-stream")) && (
                                <a href={previewUrl} download="document" style={{ color: "blue" }}>
                                    Click here to download file
                                </a>
                            )}
                    </>
                )}
            </div>
            {html && (
                <div>
                    <div className="d-flex justify-content-end">
                        <Button
                            // variant="primary"
                            className="d-flex align-items-center me-0 text-nowrap bg-accent"
                            onClick={handleDownloadRreport}
                        >
                            <BsDownload className="me-1" />
                            Download Report
                        </Button>
                    </div>
                    <div style={{
                        border: "2px solid #ddd",
                        padding: "16px",
                        borderRadius: "8px",
                        marginTop: "20px",
                        textAlign: "left"
                    }}>
                        <h2>Due Diligence</h2>
                        <div
                            className="mt-5"
                            dangerouslySetInnerHTML={{ __html: html }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
export default Opportunity;